import { put, call, takeEvery } from "redux-saga/effects";
import { axiosInstance, apiURL } from "constants/config";
import toast from "react-hot-toast";

import {
  loadUsersRequested,
  loadUsersSuccess,
  loadUsersFail,
  storeAssignRoleRequested,
  storeAssignRoleFail,
  storeAssignRoleSuccess,
  storeUserFail,
  storeUserRequested,
  storeUserSuccess,
  loadCustomersFail,
  loadCustomersRequested,
  loadCustomersSuccess,
  loadSingleCustomerFail,
  loadSingleCustomerRequested,
  loadSingleCustomerSuccess,
  deleteUserRequested,
  deleteUserSuccess,
  deleteUserFail,
} from "./userSlice";

export function* loadUsersEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/users?SearchValue=${
        action?.payload?.filters?.query ?? ""
      }&PaginationOption.Page=${
        action.payload.page
      }&PaginationOption.PageSize=${action.payload.perPage}`
    );

    yield put(loadUsersSuccess(data));
  } catch (error: any) {
    yield put(loadUsersFail(error.message));
  }
}

export function* loadSingleCustomerEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(axiosInstance.get, `${apiURL}/get-customer`);
    yield put(loadSingleCustomerSuccess(data));
  } catch (error: any) {
    yield put(loadSingleCustomerFail(error.message));
  }
}
export function* loadCustomersEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/user-index?userType=1&searchString=${
        action?.payload?.filters?.query ?? ""
      }&page=${action.payload.page}&pageSize=${action.payload.perPage}`
    );

    yield put(loadCustomersSuccess(data));
  } catch (error: any) {
    yield put(loadCustomersFail(error.message));
  }
}

export function* storeUserEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/register`,
      action.payload
    );
    if (data?.status) {
      yield put(storeUserSuccess(data));
      yield call(loadUsersEffect, {
        payload: {
          perPage: 1000,
          page: 1,
        },
        type: "",
      });
      toast.success("User created successfully");
    } else {
      toast.error(data?.errors);
    }
  } catch (error: any) {
    yield put(storeUserFail(error.message));
  }
}

export function* storeAssignRoleEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/assign-role-to-user`,
      action.payload
    );

    if (data?.result) {
      yield put(storeAssignRoleSuccess(data));
      yield call(loadUsersEffect, {
        payload: {
          perPage: 1000,
          page: 1,
        },
        type: "",
      });

      toast.success("Role assigned successfully");
    } else {
      toast.error(data?.errors || "An unknown error occurred");
    }
  } catch (error: any) {
    yield put(storeAssignRoleFail(error.message));
  }
}

export function* deleteUserEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.delete,
      `${apiURL}/user/${action.payload?.item?.id}`,
      action.payload?.item
    );
    if (data?.succeeded) {
      yield put(deleteUserSuccess(data));
      toast.success("User deleted successfully");
    }
  } catch (error: any) {
    yield put(deleteUserFail(error.message));
  }
}

export function* usersSaga(): Generator<any, void, any> {
  yield takeEvery(loadUsersRequested, loadUsersEffect);
  yield takeEvery(storeUserRequested, storeUserEffect);
  yield takeEvery(storeAssignRoleRequested, storeAssignRoleEffect);
  yield takeEvery(loadCustomersRequested, loadCustomersEffect);
  yield takeEvery(loadSingleCustomerRequested, loadSingleCustomerEffect);
  yield takeEvery(deleteUserRequested, deleteUserEffect);
}
